import { useState, useEffect } from 'react'
import { supabase } from './lib/supabase'
import Login from './pages/auth/Login'
import StravaCallback from './pages/auth/StravaCallback'
import AthleteDashboard from './pages/athlete/AthleteDashboard'
import CoachDashboard from './pages/coach/CoachDashboard'
import AdminDashboard from './pages/admin/AdminDashboard'
import ParentDashboard from './pages/parent/ParentDashboard'

function App() {
  const [session, setSession] = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  const fetchProfile = async (userId) => {
    const { data } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .single()
  
  if (data) {
    setProfile(data)
  } else {
    // Fallback: ambil role dari JWT langsung
    const { data: { session } } = await supabase.auth.getSession()
    const token = session?.access_token
    if (token) {
      const payload = JSON.parse(atob(token.split('.')[1]))
      setProfile({ id: userId, role: payload.user_role })
    }
  }
  setLoading(false)
}

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) fetchProfile(session.user.id)
      else setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        setSession(session)
        if (session) fetchProfile(session.user.id)
        else {
          setProfile(null)
          setLoading(false)
        }
      }
    )

    return () => subscription.unsubscribe()
  }, [])

  // ── Strava OAuth callback ─────────────────────────────────
  // Tangkap /strava/callback sebelum cek session
  if (window.location.pathname === '/strava/callback') {
    return (
      <StravaCallback
        onSuccess={() => window.location.replace('/')}
        onError={() => window.location.replace('/')}
      />
    )
  }

  if (loading) return (
    <div style={{
      minHeight: '100vh',
      background: '#0f172a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#38bdf8',
      fontSize: '1.2rem'
    }}>
      Loading...
    </div>
  )

  if (!session) return <Login />

  const role = profile?.role

  if (role === 'athlete') return <AthleteDashboard profile={profile} />
  if (role === 'coach')   return <CoachDashboard profile={profile} />
  if (role === 'admin')   return <AdminDashboard profile={profile} />
  if (role === 'parent')  return <ParentDashboard profile={profile} />

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0f172a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <p style={{ color: '#f1f5f9' }}>Role belum diset untuk akun ini.</p>
      <button
        onClick={() => supabase.auth.signOut()}
        style={{
          padding: '0.5rem 1.5rem',
          background: '#ef4444',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer'
        }}
      >
        Keluar
      </button>
    </div>
  )
}

export default App